<template>
    <div @click="clickEvents" :class="{'bg-yellow' : clicked}" class="checkboxSize ba b--light-gray pointer">
        <img v-if="clicked" src="@/assets/img/icon_check_simple.svg"/>
    </div>
</template>

<script>
export default {
    data() {
        return {
            clicked: this.value
        };
    },
    props: {
        value: {
            type: Boolean
        }
    },
    methods: {
        clickEvents() {
            this.clicked = !this.clicked;
            this.$emit('input', this.clicked);
        }
    }
};
</script>


<style scoped>
.checkboxSize {
    width: 23px;
    height: 23px;
}
</style>
